import { useEffect, useState, useCallback } from "react";
import api from "api";
import { showGlobalModal } from "utils/modalEmitter";

const useSubscriptionData = token => {
  const [plans, setPlans] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subscriptionDetail, setSubscriptionDetail] = useState({
    plan: "Nenhum plano ativo",
    status: "inactive",
    amount: 0,
    current_period_end: null,
    is_canceled: false
  });

  const fetchData = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const [subscriptionRes, invoicesRes, plansRes] = await Promise.all([
        api.get("/stripe/subscription/detail", { headers }),
        api.get("/plans/invoices", { headers }),
        api.get("/v2/stripe/plans", { headers })
      ]);

      if (subscriptionRes.data) {
        setSubscriptionDetail(subscriptionRes.data);
      }

      setInvoices(invoicesRes.data || []);
      setPlans(plansRes.data || []);
    } catch (err) {
      console.error("Erro ao buscar dados da assinatura:", err);
      showGlobalModal({ variant: "error", title: "Erro", message: "Não foi possível carregar os dados da sua assinatura." });
    } finally {
      setLoading(false);
    }
  }, [token]);

  const handleSubscribe = async planName => {
    try {
      const response = await api.post(
        "/stripe/create-checkout-session",
        { plan_name: planName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Erro ao criar sessão de checkout:", error);
      showGlobalModal({ variant: "error", title: "Erro", message: "Não foi possível iniciar o processo de assinatura." });
    }
  };

  const handleManageSubscription = async () => {
    try {
      const response = await api.post(
        "/stripe/create-portal-session",
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Erro ao acessar o portal do cliente:", error);
      showGlobalModal({ variant: "error", title: "Erro", message: "Não foi possível acessar o portal de gerenciamento." });
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    plans,
    invoices,
    loading,
    subscriptionDetail,
    fetchData,
    handleSubscribe,
    handleManageSubscription
  };
};

export default useSubscriptionData;
